export default __webpack_public_path__ + "static/media/CarRed.b4cc6904.png";